import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/_provider/general.service';
import * as semver from "semver"
import { environment } from 'src/environments/environment';

@Component({
    selector: 'server-compatibility',
    templateUrl: './server-compatibility.component.html',
    styleUrls: ['./server-compatibility.component.scss'],
    standalone: false
})
export class ServerCompatibilityComponent implements OnInit {

  public version: string = ""

  constructor(
    public generalSrv: GeneralService,
  ) { 
    this.version = environment.version
  }

  ngOnInit() {
  }

  public get versionCompatibility(){

    const compatibleServerVersions = environment?.compatible_server_versions || []
    if(compatibleServerVersions.includes(this.generalSrv?.webConfig?.version)) return 0

    if(!this.generalSrv?.webConfig?.compatible_app_versions) return 0 
    if(this.generalSrv?.webConfig?.compatible_app_versions.includes(this.version)) return 0
    if(this.generalSrv?.webConfig?.compatible_app_versions.every(version =>  semver.lt(this.version, version))) return 1
    return 2

    // if(!this.generalSrv?.webConfig?.version) return 0
    // if(this.generalSrv?.webConfig?.version == this.version) return 0
    // if(semver.lt(this.version, this.generalSrv?.webConfig?.version)) return 1
    // return 2
  } 

}
